module.exports = __webpack_public_path__ + "static/img/200127.503f560f.png";